import { Component } from "react";
import Error from "./Error";
import Loader from "react-loaders";
import IframeContainer from "./IframeContainer";
import PropTypes from "prop-types";

import "../../sass/main.css";

export class AppContainer extends Component {
  constructor() {
    super();
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    const iframeParam = this.props.code;
    if (!iframeParam) {
      this.setState({
        loading: false,
        error: "missingParam",
      });
    } else {
      this.loadSource(iframeParam);
    }
  }

  loadSource(iframeParam) {
    const srcRegex = /(src)=["']([^"']*)["']/;
    let result = iframeParam.match(srcRegex);
    if (result === null) {
      this.setState({
        loading: false,
        error: "invalidIframe",
      });
    } else {
      let source = result[2];
      this.setState({
        loading: false,
        source,
      });
    }
  }

  setError = (error) => {
    this.setState({ error });
  };

  render() {
    if (this.state.loading) {
      return (
        <Loader
          type="ball-grid-pulse"
          color="#fff"
          style={{ transform: "scale(2)" }}
        />
      );
    } else {
      if (this.state.error) {
        this.props.sc.emitFinished({
          error: {
            code: 400,
            message: this.state.error,
          },
        });
        return <Error error={this.state.error} />;
      } else {
        // limit zoom to 10 max
        let zoom = this.props.zoom > 10 ? 10 : this.props.zoom;
        let pageScale = (zoom * window.innerWidth) / 1920;

        if (isNaN(pageScale) === false) {
          if (pageScale <= 1) {
            pageScale = 1;
          }
        }

        return (
          <IframeContainer
            source={this.state.source}
            setError={this.setError}
            pageScale={pageScale}
          />
        );
      }
    }
  }
}

AppContainer.propTypes = {
  code: PropTypes.string,
  zoom: PropTypes.number,
  sc: PropTypes.object,
};
